module.exports = __webpack_public_path__ + "static/media/navisworks.cfcc914e.png";